import React from "react";
import "./Button.scss";

const Button = ({
  label,
  onClick,
  style,
  disabled = false,
  type = "button",
  variant,
  className = "",
  labelStyle = "",
  loading = false,
  icon = null,
  iconAlignLeft = false,
}) => {
  return (
    <div
      className={`button-container ${className} ${disabled || loading ? "btn-disabled" : ""} ${variant === "secondary" ? "secondary" : ""}`}
      onClick={!disabled && !loading ? onClick : undefined}
    >
      <button
        className="button"
        type={type}
        style={style}
        disabled={disabled || loading}
      >
        {/* Render icon on the left if iconAlignLeft is true */}
        {iconAlignLeft && icon && <span className="button-icon">{icon}</span>}

        {loading ? (
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        ) : null}

        {label && <span className={`button-label ${labelStyle}`}>{label}</span>}

        {/* Render icon on the right if iconAlignLeft is false */}
        {!iconAlignLeft && icon && <span className="button-icon">{icon}</span>}
      </button>
    </div>
  );
};

export default Button;
